import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import LookUpAction from "./LookUpAction";
import ComuneModel from "./models/ComuneModel";
import ILookUpsState from "./models/ILookUpsState";
import TipoDocumentoModel from "./models/TipoDocumentoModel";
import CittadinanzaModel from "./models/CittadinanzaModel";
import NazioneModel from "./models/NazioneModel";
import TipoIndirizzoModel from "./models/TipoIndirizzoModel";
import AmministrazioneModel from "./models/AmministrazioneModel";
import TipoRichiedenteModel from "stores/tipo-richiedente/models/TipoRichiedenteModel";
import ConsensoPrivacyModel from "stores/consenso-privacy/models/ConsensoPrivacyModel";
import FondoModel from "./models/FondoModel";
import CqsOnlineTipoCodiceFiscaleModel from "stores/cqsonline/models/CqsOnlineTipoCodiceFiscaleModel";
import ModalitaErogazioneModel from "./models/ModalitaErogazioneModel";
import TipologiaPensioneModel from "./models/TipologiaPensioneModel";
import CategoriaAmministrativaModel from "./models/CategoriaAmministrativaModel";
import TipologiaImpegnoModel from "./models/TipologiaImpegnoModel";
import QuoteSocietaModel from "./models/QuoteSocietaModel";
import ImportoConIntermediariModel from "./models/ImportoConIntermediariModel";
import IstitutoFinanziarioModel from "./models/IstitutoFinanziarioModel";

export default class LookUpReducer extends BaseReducer<ILookUpsState> {
    public readonly initialState: ILookUpsState = {
        consensoPrivacyItems: [] as ConsensoPrivacyModel[],
        tipoRichiedenteItems: [] as TipoRichiedenteModel[],
        comuneNascitaItems: [] as ComuneModel[],
        comuneResidenzaItems: [] as ComuneModel[],
        tipoDocumentoItems: [] as TipoDocumentoModel[],
        cittadinanzaItems: [] as CittadinanzaModel[],
        nazioneItems: [] as NazioneModel[],
        tipoIndirizzoItems: [] as TipoIndirizzoModel[],
        amministrazioneItems: [] as AmministrazioneModel[],
        fondoItems: [] as FondoModel[],
        tipoCodiceFiscaleItemsCqsOnline: [] as CqsOnlineTipoCodiceFiscaleModel[],
        modalitaErogazioneItems: [] as ModalitaErogazioneModel[],
        tipologiaPensioneItems: [] as TipologiaPensioneModel[],
        categoriaAmministrativaItems: [] as CategoriaAmministrativaModel[],
        tipologiaImpegnoItems: [] as TipologiaImpegnoModel[],
        vociAmministrazioneItems: [] as AmministrazioneModel[],
        quoteSocietaItems: [] as QuoteSocietaModel[],
        importiIntermediariItems: [] as ImportoConIntermediariModel[],
        istitutoFinanziarioItems: [] as IstitutoFinanziarioModel[],
        // qualificaItems: [] as QualificaModel[],
    };

    public [LookUpAction.REQUEST_CONSENSO_PRIVACY_FINISHED](
        state: ILookUpsState,
        action: IAction<ConsensoPrivacyModel[]>
    ): ILookUpsState {
        return {
            ...state,
            consensoPrivacyItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPO_RICHIEDENTES_FINISHED](
        state: ILookUpsState,
        action: IAction<TipoRichiedenteModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipoRichiedenteItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_COMUNE_NASCITA_FINISHED](
        state: ILookUpsState,
        action: IAction<ComuneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            comuneNascitaItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_COMUNE_RESIDENZA_FINISHED](
        state: ILookUpsState,
        action: IAction<ComuneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            comuneResidenzaItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPO_DOCUMENTO_FINISHED](
        state: ILookUpsState,
        action: IAction<TipoDocumentoModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipoDocumentoItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_CITTADINANZA_FINISHED](
        state: ILookUpsState,
        action: IAction<CittadinanzaModel[]>
    ): ILookUpsState {
        return {
            ...state,
            cittadinanzaItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_NAZIONE_FINISHED](
        state: ILookUpsState,
        action: IAction<NazioneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            nazioneItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPO_INDIRIZZO_FINISHED](
        state: ILookUpsState,
        action: IAction<TipoIndirizzoModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipoIndirizzoItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_AMMINISTRAZIONE_FINISHED](
        state: ILookUpsState,
        action: IAction<AmministrazioneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            amministrazioneItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_FONDO_FINISHED](state: ILookUpsState, action: IAction<FondoModel[]>): ILookUpsState {
        return {
            ...state,
            fondoItems: action.payload!,
        };
    }

    // #region CQSonline
    public [LookUpAction.REQUEST_TIPO_DOCUMENTO_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<TipoDocumentoModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipoDocumentoItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPO_CODICE_FISCALE_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<CqsOnlineTipoCodiceFiscaleModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipoCodiceFiscaleItemsCqsOnline: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_MODALITA_EROGAZIONE_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<ModalitaErogazioneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            modalitaErogazioneItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPOLOGIA_PENSIONE_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<TipologiaPensioneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipologiaPensioneItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<CategoriaAmministrativaModel[]>
    ): ILookUpsState {
        return {
            ...state,
            categoriaAmministrativaItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_TIPOLOGIA_IMPEGNO_CQSOL_FINISHED](
        state: ILookUpsState,
        action: IAction<TipologiaImpegnoModel[]>
    ): ILookUpsState {
        return {
            ...state,
            tipologiaImpegnoItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE_FINISHED](
        state: ILookUpsState,
        action: IAction<AmministrazioneModel[]>
    ): ILookUpsState {
        return {
            ...state,
            vociAmministrazioneItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_QUOTE_SOCIETARIE_FINISHED](
        state: ILookUpsState,
        action: IAction<QuoteSocietaModel[]>
    ): ILookUpsState {
        return {
            ...state,
            quoteSocietaItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_IMPORTI_INTERMEDIARI_FINISHED](
        state: ILookUpsState,
        action: IAction<ImportoConIntermediariModel[]>
    ): ILookUpsState {
        return {
            ...state,
            importiIntermediariItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_GET_CONSENSI_USER_FINISHED](
        state: ILookUpsState,
        action: IAction<ConsensoPrivacyModel[]>
    ): ILookUpsState {
        return {
            ...state,
            consensoPrivacyItems: action.payload!,
        };
    }

    public [LookUpAction.REQUEST_ISTITUTO_FINANZIARIO_FINISHED](
        state: ILookUpsState,
        action: IAction<IstitutoFinanziarioModel[]>
    ): ILookUpsState {
        return {
            ...state,
            istitutoFinanziarioItems: action.payload!,
        };
    }

    // #endregion CQSonline

    //campo non necessario
    /*   public [LookUpAction.REQUEST_QUALIFICA_FINISHED](
        state: ILookUpsState,
        action: IAction<QualificaModel[]>
    ): ILookUpsState {
        return {
            ...state,
            qualificaItems: action.payload!,
        };
    } */
}
